module.exports = __webpack_public_path__ + "media/7.f64c59c3.mp3";